import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M17.104 19.25h-.757V4.75h.757v14.5zm-10.208-.677 7.609-6.583-7.609-6.563.607-.677 8.405 7.24-8.405 7.26-.607-.677z"
}), 'ArrowEndRight');